export default __webpack_public_path__ + "static/media/003.a8c9a12e.png";